import React from "react"
import styled from "styled-components"
import { getCssSizeValue, getPaddingsClassFromData } from "@/utils/utils"
import StructuredText from "@/components/common/StructuredText"
import { useRouter } from "next/router"
import { PAGES } from "@/constants"
import FallingCross from "@/components/common/FallingCross"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled.div`
	position: relative;
	z-index: 2;
	width: 100%;

	.full-width {
		width: 100%;
	}

	.full-width-to-left {
		width: 100vw;
		padding: 0;
		//margin-left: calc(var(--paddingX) * (-1));
		background-color: indigo;
		@media (min-width: 1280px) and (orientation: landscape) {
			//margin-left: calc(-1 * (100vw - 1030px) / 2);
		}
	}

	&.thank-you-page {
		margin-top: ${getCssSizeValue(96, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			margin-top: ${getCssSizeValue(124, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-top: ${getCssSizeValue(24)};
		}
	}
`

const StructuredTextModule = ({ data, className = "" }) => {
	const router = useRouter()
	const isThankYouPage = router.asPath.includes(PAGES.THANK_YOU)
	const indent = isThankYouPage ? 3 : 5
	const width = isThankYouPage ? 8 : 6

	const paddings = getPaddingsClassFromData(data)
	const content = data?.content || []

	return (
		<Wrapper className={`${paddings} ${className} ${isThankYouPage ? "thank-you-page" : ""}`}>
			{isThankYouPage && <FallingCross />}
			<StructuredText data={content} indent={indent} width={width} />
		</Wrapper>
	)
}

export default StructuredTextModule
